import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const [menuActive, setMenuActive] = useState(false);
  const location = useLocation();

  const closeMenu = () => setMenuActive(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link
          to="/"
          onClick={closeMenu}
          style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}
        >
          <img
            src="/whooppe-logo.png"
            alt="Whooppe by Thrillathon"
            style={{ height: 68, width: 'auto', objectFit: 'contain' }}
          />
        </Link>

        <ul className={`nav-menu ${menuActive ? 'active' : ''}`}>
          {[
            { to: '/',        label: 'Home' },
            { to: '/shows',   label: 'Shows' },
            { to: '/contact', label: 'Contact' },
          ].map(({ to, label }) => (
            <li key={to} className="nav-item">
              <Link
                to={to}
                className={`nav-link ${location.pathname === to ? 'active' : ''}`}
                onClick={closeMenu}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        <a
          href="https://play.google.com/store/apps/details?id=com.thrillathon.whooppeapp"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-app"
        >
          Get the App
        </a>

        <div
          className={`hamburger ${menuActive ? 'active' : ''}`}
          onClick={() => setMenuActive((v) => !v)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
